<script>
    import {jobs} from "../resume-store";
</script>

<!--------------------------------------------------------------------------------------------------------------------->


<div class="experience">
    {#each $jobs as job (job.id)}
        <div class="job">
            <h4>{job.title}</h4>
            <h5>{job.company}</h5>
            <h6>{job.period}</h6>
            <p>{job.desc}</p>
        </div>
    {/each}
</div>

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    .experience {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        flex-basis: available;
    }

    .job {
        flex-basis: 340px;
        margin-bottom: 20px;
        margin-top: 5px;
    }

    @media screen and (max-width: 500px) {
        .job {
            flex-basis: unset;
        }
    }
</style>